const importImage = (imageName) => {
  try {
    return require(`../../assets/images/${imageName}`);
  } catch (err) {
    console.error("Image not found:", imageName);
    return null;
  }
};

export default importImage;